var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "config-list" },
    [
      _c("v-tour", {
        attrs: {
          name: "spider-detail-config",
          steps: _vm.tourSteps,
          callbacks: _vm.tourCallbacks,
          options: _vm.$utils.tour.getOptions(true)
        }
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            title: _vm.$t("Preview Results"),
            width: "90%",
            "before-close": _vm.onDialogClose
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-table",
            {
              staticClass: "table-header",
              attrs: { data: [{}], "show-header": false }
            },
            _vm._l(_vm.fields, function(f, index) {
              return _c(
                "el-table-column",
                { key: f.name + "-" + index, attrs: { "min-width": "100px" } },
                [
                  [
                    _c("el-input", {
                      staticStyle: { width: "calc(100% - 15px)" },
                      attrs: { size: "mini" },
                      model: {
                        value: _vm.columnsDict[f.name],
                        callback: function($$v) {
                          _vm.$set(_vm.columnsDict, f.name, $$v)
                        },
                        expression: "columnsDict[f.name]"
                      }
                    }),
                    _c(
                      "a",
                      {
                        staticStyle: { "margin-left": "2px" },
                        attrs: { href: "javascript:" },
                        on: {
                          click: function($event) {
                            return _vm.onDeleteField(index)
                          }
                        }
                      },
                      [_vm._v("X")]
                    )
                  ]
                ],
                2
              )
            }),
            1
          ),
          _c(
            "el-table",
            {
              attrs: {
                data: _vm.previewCrawlData,
                "show-header": false,
                border: ""
              }
            },
            _vm._l(_vm.fields, function(f, index) {
              return _c("el-table-column", {
                key: f.name + "-" + index,
                attrs: { label: f.name, "min-width": "100px" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(_vm.getDisplayStr(scope.row[f.name])) +
                              " "
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  true
                )
              })
            }),
            1
          )
        ],
        1
      ),
      _c("crawl-confirm-dialog", {
        attrs: {
          visible: _vm.crawlConfirmDialogVisible,
          "spider-id": _vm.spiderForm._id
        },
        on: {
          close: function($event) {
            _vm.crawlConfirmDialogVisible = false
          }
        }
      }),
      _c(
        "el-tabs",
        {
          attrs: { "active-name": _vm.activeTab },
          on: { "tab-click": _vm.onTabClick }
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { name: "stages", label: _vm.$t("Stages") } },
            [
              _c(
                "el-row",
                [
                  _c("el-form", {
                    ref: "form",
                    attrs: {
                      "label-width": "150px",
                      model: _vm.spiderForm.config
                    }
                  })
                ],
                1
              ),
              _c("el-row", [
                _c("div", { staticClass: "top-wrapper" }, [
                  _c("ul", { staticClass: "list" }, [
                    _c(
                      "li",
                      { staticClass: "item" },
                      [
                        _c("label", [
                          _vm._v(_vm._s(_vm.$t("Start URL")) + ": ")
                        ]),
                        _c("el-input", {
                          class: _vm.startUrlClass,
                          attrs: {
                            id: "start-url",
                            placeholder: _vm.$t("Start URL")
                          },
                          model: {
                            value: _vm.spiderForm.config.start_url,
                            callback: function($$v) {
                              _vm.$set(_vm.spiderForm.config, "start_url", $$v)
                            },
                            expression: "spiderForm.config.start_url"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "li",
                      { staticClass: "item" },
                      [
                        _c("label", [
                          _vm._v(_vm._s(_vm.$t("Start Stage")) + ": ")
                        ]),
                        _c(
                          "el-select",
                          {
                            class: _vm.startStageClass,
                            attrs: {
                              id: "start-stage",
                              placeholder: _vm.$t("Start Stage")
                            },
                            on: {
                              change: function($event) {
                                return _vm.$st.sendEv(
                                  "爬虫详情",
                                  "配置",
                                  "改变起始阶段"
                                )
                              }
                            },
                            model: {
                              value: _vm.spiderForm.config.start_stage,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.spiderForm.config,
                                  "start_stage",
                                  $$v
                                )
                              },
                              expression: "spiderForm.config.start_stage"
                            }
                          },
                          _vm._l(
                            _vm.spiderForm.config.stages.map(function(s) {
                              return s.name
                            }),
                            function(n) {
                              return _c("el-option", {
                                key: n,
                                attrs: { value: n, label: n }
                              })
                            }
                          ),
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "li",
                      { staticClass: "item" },
                      [
                        _c("label", [_vm._v(_vm._s(_vm.$t("Engine")) + ": ")]),
                        _c(
                          "el-select",
                          {
                            class: _vm.startStageClass,
                            attrs: {
                              placeholder: _vm.$t("Start Stage"),
                              disabled: ""
                            },
                            model: {
                              value: _vm.spiderForm.config.engine,
                              callback: function($$v) {
                                _vm.$set(_vm.spiderForm.config, "engine", $$v)
                              },
                              expression: "spiderForm.config.engine"
                            }
                          },
                          _vm._l(["scrapy"], function(n) {
                            return _c("el-option", {
                              key: n,
                              attrs: { value: n, label: n }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _c("li", { staticClass: "item" }, [
                      _c("label", [
                        _vm._v(_vm._s(_vm.$t("Selector Type")) + ": ")
                      ]),
                      _c("div", { staticClass: "selector-type" }, [
                        _c(
                          "span",
                          {
                            staticClass: "selector-type-item",
                            on: {
                              click: function($event) {
                                return _vm.onClickSelectorType("css")
                              }
                            }
                          },
                          [
                            _c(
                              "el-tag",
                              {
                                class: _vm.isCss ? "active" : "inactive",
                                attrs: { type: "success" }
                              },
                              [_vm._v(" CSS ")]
                            )
                          ],
                          1
                        ),
                        _c(
                          "span",
                          {
                            staticClass: "selector-type-item",
                            on: {
                              click: function($event) {
                                return _vm.onClickSelectorType("xpath")
                              }
                            }
                          },
                          [
                            _c(
                              "el-tag",
                              {
                                class: _vm.isXpath ? "active" : "inactive",
                                attrs: { type: "primary" }
                              },
                              [_vm._v(" XPath ")]
                            )
                          ],
                          1
                        )
                      ])
                    ])
                  ])
                ]),
                _c("div", { staticClass: "button-group-container" }, [
                  _c(
                    "div",
                    { staticClass: "button-group" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            id: "btn-run",
                            size: "small",
                            type: "danger",
                            disabled: _vm.isDisabled,
                            icon: "el-icon-video-play"
                          },
                          on: { click: _vm.onCrawl }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("Run")) + " ")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            id: "btn-convert",
                            size: "small",
                            type: "warning",
                            disabled: _vm.isDisabled,
                            icon: "el-icon-refresh-right"
                          },
                          on: { click: _vm.onConvert }
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("Convert to Customized")) + " "
                          )
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            id: "btn-save",
                            size: "small",
                            type: "success",
                            disabled: _vm.saveLoading || _vm.isDisabled,
                            icon: _vm.saveLoading
                              ? "el-icon-loading"
                              : "el-icon-check"
                          },
                          on: { click: _vm.onSave }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("Save")) + " ")]
                      )
                    ],
                    1
                  )
                ])
              ]),
              _c(
                "el-collapse",
                { attrs: { value: _vm.activeNames } },
                _vm._l(_vm.spiderForm.config.stages, function(stage, index) {
                  return _c(
                    "el-collapse-item",
                    { key: index, attrs: { name: stage.name } },
                    [
                      _c("template", { slot: "title" }, [
                        _c("ul", { staticClass: "stage-list" }, [
                          _c(
                            "li",
                            {
                              staticClass: "stage-item actions",
                              staticStyle: {
                                "min-width": "80px",
                                "flex-basis": "80px",
                                "justify-content": "flex-end"
                              },
                              on: {
                                click: function($event) {
                                  return $event.stopPropagation()
                                }
                              }
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "action-item el-icon-copy-document",
                                on: {
                                  click: function($event) {
                                    return _vm.onCopyStage(stage)
                                  }
                                }
                              }),
                              _c("i", {
                                staticClass:
                                  "action-item el-icon-remove-outline",
                                on: {
                                  click: function($event) {
                                    return _vm.onRemoveStage(stage)
                                  }
                                }
                              }),
                              _c("i", {
                                staticClass:
                                  "action-item el-icon-circle-plus-outline",
                                on: {
                                  click: function($event) {
                                    return _vm.onAddStage(stage)
                                  }
                                }
                              })
                            ]
                          ),
                          _c(
                            "li",
                            {
                              staticClass: "stage-item",
                              staticStyle: { "min-width": "240px" },
                              on: {
                                click: function($event) {
                                  return $event.stopPropagation()
                                }
                              }
                            },
                            [
                              _c("label", [
                                _vm._v(_vm._s(_vm.$t("Stage Name")) + ": ")
                              ]),
                              !stage.isEdit
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "text-wrapper",
                                      on: {
                                        click: function($event) {
                                          return _vm.onEditStage(stage)
                                        }
                                      }
                                    },
                                    [
                                      _c("span", { staticClass: "text" }, [
                                        _vm._v(" " + _vm._s(stage.name) + " ")
                                      ]),
                                      _c("i", {
                                        staticClass: "el-icon-edit-outline"
                                      })
                                    ]
                                  )
                                : _c("el-input", {
                                    ref: "stage-name-" + stage.name,
                                    refInFor: true,
                                    staticClass: "edit-text",
                                    attrs: {
                                      placeholder: _vm.$t("Stage Name")
                                    },
                                    on: {
                                      focus: function($event) {
                                        return _vm.onStageNameFocus($event)
                                      },
                                      blur: function($event) {
                                        stage.isEdit = false
                                      }
                                    },
                                    model: {
                                      value: stage.name,
                                      callback: function($$v) {
                                        _vm.$set(stage, "name", $$v)
                                      },
                                      expression: "stage.name"
                                    }
                                  })
                            ],
                            1
                          ),
                          _c(
                            "li",
                            {
                              staticClass: "stage-item",
                              staticStyle: { "min-width": "240px" }
                            },
                            [
                              _c("label", [
                                _vm._v(_vm._s(_vm.$t("List")) + ": ")
                              ]),
                              _c("el-checkbox", {
                                staticStyle: {
                                  "text-align": "left",
                                  "flex-basis": "20px",
                                  "margin-right": "5px"
                                },
                                attrs: { value: _vm.isList(stage) },
                                on: {
                                  change: function($event) {
                                    return _vm.onCheckIsList($event, stage)
                                  }
                                }
                              }),
                              _vm.isList(stage)
                                ? _c(
                                    "el-popover",
                                    {
                                      attrs: { placement: "top", width: "360" },
                                      model: {
                                        value: stage.isListOpen,
                                        callback: function($$v) {
                                          _vm.$set(stage, "isListOpen", $$v)
                                        },
                                        expression: "stage.isListOpen"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-form",
                                        { attrs: { "label-width": "120px" } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: _vm.$t("Selector Type")
                                              }
                                            },
                                            [
                                              _c(
                                                "el-tag",
                                                {
                                                  class: !stage.list_xpath
                                                    ? "active"
                                                    : "inactive",
                                                  attrs: { type: "success" },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.onSelectStageListType(
                                                        stage,
                                                        "css"
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("CSS ")]
                                              ),
                                              _c(
                                                "el-tag",
                                                {
                                                  class: stage.list_xpath
                                                    ? "active"
                                                    : "inactive",
                                                  attrs: { type: "primary" },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.onSelectStageListType(
                                                        stage,
                                                        "xpath"
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("XPath ")]
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-form-item",
                                            {
                                              staticClass: "list-selector",
                                              attrs: {
                                                label: _vm.$t("Selector")
                                              }
                                            },
                                            [
                                              !stage.list_xpath
                                                ? _c("el-input", {
                                                    model: {
                                                      value: stage.list_css,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          stage,
                                                          "list_css",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "stage.list_css"
                                                    }
                                                  })
                                                : _c("el-input", {
                                                    model: {
                                                      value: stage.list_xpath,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          stage,
                                                          "list_xpath",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "stage.list_xpath"
                                                    }
                                                  })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      !stage.list_xpath
                                        ? _c(
                                            "el-tag",
                                            {
                                              attrs: {
                                                slot: "reference",
                                                type: "success"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.onClickStageList(
                                                    $event,
                                                    stage,
                                                    "css"
                                                  )
                                                }
                                              },
                                              slot: "reference"
                                            },
                                            [
                                              !stage.isListOpen
                                                ? _c("i", {
                                                    staticClass:
                                                      "el-icon-circle-plus-outline"
                                                  })
                                                : _c("i", {
                                                    staticClass:
                                                      "el-icon-remove-outline"
                                                  }),
                                              _vm._v(" CSS ")
                                            ]
                                          )
                                        : _c(
                                            "el-tag",
                                            {
                                              attrs: {
                                                slot: "reference",
                                                type: "primary"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.onClickStageList(
                                                    $event,
                                                    stage,
                                                    "xpath"
                                                  )
                                                }
                                              },
                                              slot: "reference"
                                            },
                                            [
                                              !stage.isListOpen
                                                ? _c("i", {
                                                    staticClass:
                                                      "el-icon-circle-plus-outline"
                                                  })
                                                : _c("i", {
                                                    staticClass:
                                                      "el-icon-remove-outline"
                                                  }),
                                              _vm._v(" XPath ")
                                            ]
                                          )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _c(
                            "li",
                            {
                              staticClass: "stage-item",
                              staticStyle: { "min-width": "240px" }
                            },
                            [
                              _c("label", [
                                _vm._v(_vm._s(_vm.$t("Pagination")) + ": ")
                              ]),
                              _c("el-checkbox", {
                                staticStyle: {
                                  "text-align": "left",
                                  "flex-basis": "20px",
                                  "margin-right": "5px"
                                },
                                attrs: {
                                  value: _vm.isPage(stage),
                                  disabled: !_vm.isList(stage)
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.onCheckIsPage($event, stage)
                                  }
                                }
                              }),
                              _vm.isPage(stage)
                                ? _c(
                                    "el-popover",
                                    {
                                      attrs: { placement: "top", width: "360" },
                                      model: {
                                        value: stage.isPageOpen,
                                        callback: function($$v) {
                                          _vm.$set(stage, "isPageOpen", $$v)
                                        },
                                        expression: "stage.isPageOpen"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-form",
                                        { attrs: { "label-width": "120px" } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: _vm.$t("Selector Type")
                                              }
                                            },
                                            [
                                              _c(
                                                "el-tag",
                                                {
                                                  class: !stage.page_xpath
                                                    ? "active"
                                                    : "inactive",
                                                  attrs: { type: "success" },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.onSelectStagePageType(
                                                        stage,
                                                        "css"
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("CSS ")]
                                              ),
                                              _c(
                                                "el-tag",
                                                {
                                                  class: stage.page_xpath
                                                    ? "active"
                                                    : "inactive",
                                                  attrs: { type: "primary" },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.onSelectStagePageType(
                                                        stage,
                                                        "xpath"
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("XPath ")]
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-form-item",
                                            {
                                              staticClass: "page-selector",
                                              attrs: {
                                                label: _vm.$t("Selector")
                                              }
                                            },
                                            [
                                              !stage.page_xpath
                                                ? _c("el-input", {
                                                    model: {
                                                      value: stage.page_css,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          stage,
                                                          "page_css",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "stage.page_css"
                                                    }
                                                  })
                                                : _c("el-input", {
                                                    model: {
                                                      value: stage.page_xpath,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          stage,
                                                          "page_xpath",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "stage.page_xpath"
                                                    }
                                                  })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      !stage.page_xpath
                                        ? _c(
                                            "el-tag",
                                            {
                                              attrs: {
                                                slot: "reference",
                                                type: "success"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.onClickStagePage(
                                                    $event,
                                                    stage,
                                                    "css"
                                                  )
                                                }
                                              },
                                              slot: "reference"
                                            },
                                            [
                                              !stage.isPageOpen
                                                ? _c("i", {
                                                    staticClass:
                                                      "el-icon-circle-plus-outline"
                                                  })
                                                : _c("i", {
                                                    staticClass:
                                                      "el-icon-remove-outline"
                                                  }),
                                              _vm._v(" CSS ")
                                            ]
                                          )
                                        : _c(
                                            "el-tag",
                                            {
                                              attrs: {
                                                slot: "reference",
                                                type: "primary"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.onClickStagePage(
                                                    $event,
                                                    stage,
                                                    "xpath"
                                                  )
                                                }
                                              },
                                              slot: "reference"
                                            },
                                            [
                                              !stage.isPageOpen
                                                ? _c("i", {
                                                    staticClass:
                                                      "el-icon-circle-plus-outline"
                                                  })
                                                : _c("i", {
                                                    staticClass:
                                                      "el-icon-remove-outline"
                                                  }),
                                              _vm._v(" XPath ")
                                            ]
                                          )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ])
                      ]),
                      _c("fields-table-view", {
                        attrs: {
                          type: "list",
                          title: "List Page Fields",
                          fields: stage.fields,
                          stage: stage,
                          "stage-names": _vm.spiderForm.config.stages.map(
                            function(s) {
                              return s.name
                            }
                          )
                        }
                      })
                    ],
                    2
                  )
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { name: "process", label: _vm.$t("Process") } },
            [_c("div", { attrs: { id: "process-chart" } })]
          ),
          _c(
            "el-tab-pane",
            { attrs: { name: "settings", label: _vm.$t("Settings") } },
            [
              _c(
                "div",
                {
                  staticClass: "actions",
                  staticStyle: {
                    "text-align": "right",
                    "margin-bottom": "10px"
                  }
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "success",
                        size: "small",
                        disabled: _vm.isDisabled
                      },
                      on: { click: _vm.onSave }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("Save")) + " ")]
                  )
                ],
                1
              ),
              _c("setting-fields-table-view", { attrs: { type: "list" } })
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { name: "spiderfile", label: "Spiderfile" } },
            [
              _c(
                "div",
                { staticClass: "spiderfile-actions" },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-right": "10px" },
                      attrs: {
                        type: "primary",
                        size: "small",
                        disabled: _vm.isDisabled
                      },
                      on: { click: _vm.onSpiderfileSave }
                    },
                    [
                      _c("font-awesome-icon", {
                        attrs: { icon: ["fa", "save"] }
                      }),
                      _vm._v(" " + _vm._s(_vm.$t("Save")) + " ")
                    ],
                    1
                  )
                ],
                1
              ),
              _c("file-detail")
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }